import gql from 'graphql-tag';

export const CREATE_PETTY_CASH_ACCOUNT = gql`
  mutation createPettyCashAccount($pettyCashInput: CreatePettyCashInput!, $activityInput: CreatePettyCashActivityInput!) {
    createPettyCashAccount(pettyCashInput: $pettyCashInput, activityInput: $activityInput) {
      id
      branchId
      employeeId
      pettyCashNumber
      openingBalance
      currentBalance
      currencyId
      currencyData {
        id
        currencyCode
        currencyName
      }
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_PETTY_CASH = gql`
  mutation updatePettyCash($updatePettyCashInput: UpdatePettyCashInput!) {
    updatePettyCash(updatePettyCashInput: $updatePettyCashInput) {
      id
      projectId
      flow
      date
      description
      amount
      status
      createdAt
      updatedAt
    }
  }
`;

export const REMOVE_PETTY_CASH = gql`
  mutation removePettyCash($id: Int!) {
    removePettyCash(id: $id) {
      id
    }
  }
`;

export const CREATE_PETTY_CASH_ACTIVITY = gql`
  mutation createPettyCashActivity(
    $activityInput: CreatePettyCashActivityInput!
  ) {
    createPettyCashActivity(activityInput: $activityInput) {
      id
      cashAccountId
      type
      amount
      expenseType
      accountId
      description
      receiptUrl
      journalId
      activityStatus
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const APPROVE_OR_REJECT_PETTY_CASH_ACTIVITY = gql`
  mutation approveOrRejectPettyCashActivity(
    $activityId: Int!
    $isApproved: Boolean!
  ) {
    approveOrRejectPettyCashActivity(
      activityId: $activityId
      isApproved: $isApproved
    ) {
      id
      cashAccountId
      type
      amount
      expenseType
      accountId
      description
      receiptUrl
      approvedorRejectedBy
      IsApproved
      journalId
      activityStatus
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_PETTY_CASH_ACTIVITY = gql`
  mutation updatePettyCashActivity(
    $updatePettyCashActivityInput: UpdatePettyCashActivityInput!
    $id: Int!
  ) {
    updatePettyCashActivity(
      updatePettyCashActivityInput: $updatePettyCashActivityInput,
      id: $id
    ) {
      id
      cashAccountId
      type
      amount
      expenseType
      accountId
      description
      receiptUrl
      journalId
      activityStatus
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
